import { Box, FormGroup, FormLabel, InputAdornment, TextField } from '@mui/material'

function TextInput({
    inputProps,
    label,
    name,
    value,
    onChange,
    disabled,
}) {
  return (
    <FormGroup>
        <Box sx={{ width: '100%', display: "flex", flexDirection: "column", justifyContent: "flex-start" }}>
          <FormLabel>{label}</FormLabel>
          <TextField 
              size='small'
              sx={{ ...inputProps, minWidth: "12rem", width: "100%", height: "100%" }}
              name={name}
              value={value ?? ""}
              onChange={onChange}
              disabled={disabled || false}
          />
        </Box>
    </FormGroup>
  )
}

export default TextInput